/**
 * Observability environment configuration.
 *
 * All env vars are read from Vite's import.meta.env.
 * No defaults for DSN/URLs — if not set, the tool is disabled.
 */

export const observabilityConfig = {
  // ── Identity ───────────────────────────────────────────────
  appName: "openhub",
  appVersion: import.meta.env.VITE_APP_VERSION || "0.0.0",
  environment: import.meta.env.MODE as "development" | "staging" | "production",
  isProduction: import.meta.env.PROD,

  // ── Sentry ─────────────────────────────────────────────────
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || "",
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "")
      || (import.meta.env.PROD ? 0.1 : 1.0),
    replaysSessionSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
  },

  // ── Grafana Faro ───────────────────────────────────────────
  grafana: {
    url: import.meta.env.VITE_GRAFANA_FARO_URL || "",
    enabled: !!import.meta.env.VITE_GRAFANA_FARO_URL,
    tracesSampleRate: parseFloat(import.meta.env.VITE_GRAFANA_TRACES_SAMPLE_RATE || "")
      || (import.meta.env.PROD ? 0.2 : 1.0),
    sessionSampleRate: parseFloat(import.meta.env.VITE_GRAFANA_SESSION_SAMPLE_RATE || "")
      || (import.meta.env.PROD ? 0.1 : 1.0),
  },
} as const;
